import React, { useState } from 'react';
import { MapIcon, ShieldCheckIcon } from 'lucide-react';
import { RoadmapFlow } from '../components/roadmap/RoadmapFlow';
import { RoadmapResults } from '../components/roadmap/RoadmapResults';
import { useRoadmap } from '../hooks/useRoadmap';
import { PRIVACY_NOTE } from '../data/roadmapContent';
type Phase = 'welcome' | 'flow' | 'results';
const LOGO = 'https://cdn.magicpatterns.com/uploads/miVDHRURGJeqgpYC7Z9kCF/logo.png';
export function RoadmapPage() {
  const [phase, setPhase] = useState<Phase>('welcome');
  const {
    answers,
    results,
    set,
    setApplicant,
    setDebts,
    toggleAction,
    reset
  } = useRoadmap();
  const start = () => {
    setPhase('flow');
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  };
  const restart = () => {
    reset();
    setPhase('welcome');
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  };
  return <main className="pt-28 pb-24 bg-[#f8f9fb] dark:bg-[#0f1629] transition-colors duration-300" data-id="element-582" data-mp="2tagd28y7yry1">
      <div className={`mx-auto px-4 sm:px-6 lg:px-8 ${phase === 'results' ? 'max-w-2xl' : 'max-w-xl'}`} data-id="element-583" data-mp="2gwd2kmq3t8am">
        {phase === 'welcome' && <div className="text-center" data-id="element-584" data-mp="2c3bmwci2p4pz">
            

            <div className="mt-10 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white dark:bg-white/5 border border-slate-200 dark:border-white/10 shadow-sm dark:shadow-none" data-id="element-585" data-mp="28287fr3xtapa">
              <MapIcon className="w-4 h-4 text-primary-500" data-id="element-586" data-mp="2zupegg8egw9w" />
              <span className="text-sm font-medium text-slate-600 dark:text-slate-300" data-id="element-587" data-mp="2zs36ifhlker5">
                Free tool · a few minutes
              </span>
            </div>

            <h1 className="mt-6 text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 dark:text-white leading-[1.15]" data-id="element-588" data-mp="2qs7pvv59vrjq">
              Let's Build Your{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-500 to-primary-500" data-id="element-589" data-mp="1fevjpdm1iwue">
                Property Savings Goal
              </span>
            </h1>

            <p className="mt-5 text-lg text-slate-600 dark:text-slate-300 leading-relaxed" data-id="element-590" data-mp="1bwoaq4j6tg8w">
              Answer a few simple questions and we'll help you estimate your
              savings target, see how you're tracking and work out your next
              step.
            </p>

            <button type="button" onClick={start} className="mt-9 inline-flex items-center justify-center w-full px-8 py-5 rounded-xl bg-gradient-to-r from-accent-500 to-primary-500 text-white text-xl font-semibold transition-[transform,box-shadow] duration-200 ease-out hover:shadow-[0_0_30px_rgba(20,184,166,0.35)] hover:scale-[1.01]" data-id="element-591" data-mp="12y2uig16udba">
              Get Started
            </button>

            <p className="mt-8 flex items-start gap-2.5 text-left text-sm text-slate-500 dark:text-slate-400 leading-relaxed" data-id="element-592" data-mp="k35rv8pvx45i">
              <ShieldCheckIcon className="w-5 h-5 flex-shrink-0 text-primary-500 mt-0.5" data-id="element-593" data-mp="a7chnvzn1mqw" />
              {PRIVACY_NOTE}
            </p>
          </div>}

        {phase === 'flow' && <RoadmapFlow answers={answers} results={results} set={set} setApplicant={setApplicant} setDebts={setDebts} onFinish={() => {
        setPhase('results');
        window.scrollTo({
          top: 0,
          behavior: 'auto'
        });
      }} onExit={() => setPhase('welcome')} data-id="element-594" data-mp="f88jm40fiyto" />}

        {phase === 'results' && <RoadmapResults answers={answers} results={results} setName={name => set('name', name)} onToggleAction={toggleAction} onRestart={restart} data-id="element-595" data-mp="jgngzairu9l" />}
      </div>
    </main>;
}